import e from "./RenderString.vue_vue_type_script_setup_true_lang.js";
//#region src/schema/RenderString.vue
var t = e;
//#endregion
export { t as default };

//# sourceMappingURL=RenderString.vue.js.map